//#region src/isServer/client.ts
var isServer = false;
//#endregion
export { isServer };

//# sourceMappingURL=client.js.map